var def = require('./_').setDesc
  , has = require('./_has')
  , TAG = require('./_wks')('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-helmet/~/core-js/modules/_set-to-string-tag.js
 ** module id = 138
 ** module chunks = 0
 **/